/**
 * GENERATED FILE - DO NOT EDIT.
 *
 * Copied from couponbase-builder/packages/template-renderer/src by
 * `pnpm sync:renderer`. Edit it there and re-run the sync; a drift test fails
 * when this copy and the source disagree.
 */
const ALLOWED_TAGS = new Set([
    "a", "b", "blockquote", "br", "code", "div", "em", "h1", "h2", "h3", "h4", "h5", "h6",
    "hr", "i", "li", "ol", "p", "pre", "s", "small", "span", "strong", "sub", "sup",
    "table", "tbody", "td", "tfoot", "th", "thead", "tr", "u", "ul",
]);

const ALLOWED_ATTRS = new Set(["href", "title", "target", "rel", "colspan", "rowspan", "align"]);

/** Tags whose text content is itself the payload; unwrapping them would keep it. */
const VOID_CONTENT_TAGS = new Set(["script", "style", "iframe", "object", "embed", "noscript", "template"]);

const SAFE_URL = /^(https?:|mailto:|tel:|\/|#)/i;

function stripAllTags(html: string): string {
    // Remove payload-bearing elements with their contents first, then all remaining tags.
    return html
        .replace(/<(script|style|iframe|object|embed|noscript|template)\b[\s\S]*?<\/\1\s*>/gi, "")
        .replace(/<[^>]*>/g, "");
}

/** Sanitize a rich-text HTML fragment down to a safe allow-listed subset. */
export function sanitizeHtml(value: unknown): string {
    const html = typeof value === "string" ? value : "";
    if (!html) return "";
    if (typeof window === "undefined" || typeof window.DOMParser === "undefined") {
        return stripAllTags(html);
    }

    const parsed = new DOMParser().parseFromString(html, "text/html");
    const walk = (node: Element) => {
        for (const child of Array.from(node.children)) {
            const tag = child.tagName.toLowerCase();
            if (VOID_CONTENT_TAGS.has(tag)) {
                // script/style carry executable or layout-breaking payloads as TEXT,
                // so unwrapping them would preserve the payload. Drop them whole.
                child.remove();
                continue;
            }
            if (!ALLOWED_TAGS.has(tag)) {
                child.replaceWith(...Array.from(child.childNodes));
                continue;
            }
            for (const attr of Array.from(child.attributes)) {
                const name = attr.name.toLowerCase();
                // Drops every on* handler, style, srcset, and unknown data-* vectors.
                if (!ALLOWED_ATTRS.has(name)) {
                    child.removeAttribute(attr.name);
                    continue;
                }
                if (name === "href" && !SAFE_URL.test(attr.value.trim())) {
                    child.removeAttribute(attr.name);
                }
            }
            if (tag === "a" && child.getAttribute("target") === "_blank") {
                child.setAttribute("rel", "noopener noreferrer");
            }
            walk(child);
        }
    };
    walk(parsed.body);
    return parsed.body.innerHTML;
}

export function safeHref(value: unknown): string {
    const href = typeof value === "string" ? value.trim() : "";
    if (!href) return "#";
    return SAFE_URL.test(href) ? href : "#";
}
